import {useState} from "../../../__snowpack__/pkg/react.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useGetAvailableShelf = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post("/saas/warehouseShelves/list", params);
      setData(data2 || []);
      return data2 || [];
    } catch (error) {
      handleError(error);
      return error;
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    data,
    fetchData
  };
};
export const useUnbindShelf = () => {
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const res = await axios.get("/saas/local-inventories/warehouse-inventory-shelf-unbind", {params});
      return res;
    } catch (error) {
      handleError(error);
      return error;
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    fetchData
  };
};
export const useBindShelf = () => {
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const res = await axios.post("/saas/local-inventories/warehouse-inventory-shelf-bind", params);
      return res;
    } catch (error) {
      handleError(error);
      return error;
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    fetchData
  };
};
export const useCreateAndBindShelf = () => {
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const res = await axios.post("/saas/warehouse-shelf/init-shelf", params);
      return res;
    } catch (error) {
      handleError(error);
      return error;
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    fetchData
  };
};
